import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CommonErrorImage from 'assets/images/commonErrorBG.svg';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const NoLocation: FC = () => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      useFlexGap
      spacing={12}
      height="100%"
    >
      <CommonErrorImage />
      <Typography variant="h3">{t('simInventory.locationNotAvailable')}</Typography>
      <Typography variant="body2" maxWidth={400} textAlign="center">
        {t('simInventory.locationNotAvailableText')}
      </Typography>
    </Stack>
  );
};
